export default __webpack_public_path__ + "static/media/47UT613.6278cf39.png";